import React, { useEffect, useState } from "react";

// import LogoHorizontal from "../../../../Assets/images/logoHeaderPdf.png";
// import Logo from "../../../../Assets/images/logoMenu.png";

import {
	Document,
	Font,
	Image,
	Page,
	StyleSheet,
	Text,
	View,
} from "@react-pdf/renderer";

import Roboto from "../../../../Assets/fonts/Roboto-Bold.ttf";
import { VendaService } from "../../../../service/venda_service";

Font.register({
	family: "Roboto bold",
	format: "truetype",
	src: Roboto,
});

const styles = StyleSheet.create({
	page: {
		backgroundColor: "#00ba9d",
		paddingBottom: "20px",
		paddingTop: "5px",
		paddingLeft: "5px",
		paddingRight: "5px",
	},
	body: {
		width: "100%",
		height: "100%",
		backgroundColor: "white",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	logoPropriedade: {
		width: "auto",
		height: "60px",
		margin: "10px",
		marginBottom: "5px",
		padding: "0",
	},
	qrCode: {
		width: "auto",
		minWidth: "120px",
	},
	qrCodeContainer: {
		width: "90%",
		height: "100%",
		margin: "5px",
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-around",
		alignItems: "center",
		color: "#009199",
	},
	qrCodeTextContainer: {
		marginTop: "10px",
		display: "flex",
		height: "100%",
		width: "100%",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		color: "#009199",
	},
	qrCodeContainerTexTitle: {
		fontSize: "16px",
		textTransform: "uppercase",
		fontFamily: "Roboto bold",
		textAlign: "center",
	},
	qrCodeContainerTextSubTitle: {
		fontSize: "8px",
		textAlign: "center",
	},
	footer: {
		position: "absolute",
		width: "100vw",
		height: "18px",
		bottom: 0,
		paddingHorizontal: "10px",
	},
	logoFooter: {
		width: "auto",
		height: "15px",
	},
	containerFooter: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
	},
	paggingContainer: {
		display: "flex",
		flexDirection: "row",
	},
	paggingText: {
		alignItems: "flex-end",
		fontSize: "4px",
		paddingHorizontal: "2px",
		color: "white",
	},
});

const PdfHangTags = (props) => {
	const ids = props.ids;
	const vendaItemId = props.item; // ordemProducaoId
	const vendaId = props.venda;
	const [lote, setLote] = useState("");
	const vendaService = new VendaService();

	useEffect(() => {
		initData();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const initData = async () => {
		try {
			if (!vendaId || !vendaItemId) {
				return;
			}

			const vendaData = await vendaService.getById(vendaId);
			if (!vendaData || !vendaData.itens) {
				return;
			}

			const item = vendaData.itens.find((i) => i.ordemProducaoId === vendaItemId);
			if (item && item.ordemProducao) {
				setLote(item.ordemProducao.loteRastreabilidade || "");
			}
		} catch (error) {
			console.error("Erro ao carregar dados da venda:", error);
		}
	};

	function QRCodePage({ id }) {
		const qrElement = document.getElementById(id);
		if (!qrElement) {
			return null;
		}
		const dataUrl = qrElement.toDataURL();
		return (
			<Page
				key={`page_${id}`}
				size={{ width: 85 * 2.834645, height: 85 * 2.834645 }}
				style={styles.page}
			>
				<View style={styles.body}>
					{/* <View>
						<Image style={styles.logoPropriedade} src={LogoHorizontal} />
					</View> */}
					<View style={styles.qrCodeContainer}>
						<View>
							<Image allowDangerousPaths src={dataUrl} style={styles.qrCode} />
						</View>
						<View style={styles.qrCodeTextContainer}>
							<Text style={styles.qrCodeContainerTexTitle}>Lote {lote}</Text>
							<Text style={styles.qrCodeContainerTextSubTitle}>
								AQUI TEM RASTREABILIDADE
							</Text>
						</View>
					</View>
				</View>
				{/* roda pé  */}
				<View style={styles.footer} fixed>
					<View style={styles.containerFooter}>
						{/* <Image src={Logo} style={styles.logoFooter} /> */}
						<View style={styles.paggingContainer}>
							<View style={styles.paggingText}>
								<Text>Rastreabiidade vegetal e gestão Agrícola</Text>
								<Text style={{ fontFamily: "Roboto bold" }}>
									www.sisagri.com.br/
								</Text>
							</View>
						</View>
					</View>
				</View>
			</Page>
		);
	}
	return (
		<Document>
			{ids.map((id) => (
				<QRCodePage id={id} key={id} />
			))}
		</Document>
	);
};

export default PdfHangTags;
